import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import InstitutionsList from './InstitutionsList';
import {withLocalize} from 'react-localize-redux';
import translations from '../../translations/translations_institutions_list';
import ReactHtmlParser from 'react-html-parser';
import InstitutionsSearch from "./InstitutionsSearch";

class InstitutionsListContainer extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        const pageTitle = this.props.translate('institutions_list.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'institutions-list'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <section id="institutions-list-title">
                        <div className="row row-title">
                            <div className="col col-md-12 col-sm-8">
                                <h1>{ReactHtmlParser(this.props.translate('institutions_list.title', null, {renderInnerHtml: false}))}</h1>
                            </div>
                        </div>
                    </section>

                    <InstitutionsSearch/>
                    <InstitutionsList/>
                </div>
            </Fragment>
        );
    }
}

InstitutionsListContainer.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(InstitutionsListContainer);



// WEBPACK FOOTER //
// ./src/features/Institutions/components/List/InstitutionsListContainer.js